class DealerModel {
  DealerId = null;
  DealerName = '';
  MobileNumber = '';
  EmailId = '';
  AddressLine1 = '';
  AddressLine2 = '';
  AddressLine3 = '';
  City = '';
  State = '';
  Country = '';
  PinNumber = '';
}

export default DealerModel;